/**
 * Identite de l'application.
 *
 * Le produit n'est lie a aucun secteur d'activite : le perimetre se choisit a
 * l'import (code NAF libre, selecteur de secteur). Le nom est defini ici pour
 * qu'aucun ecran ne le reecrive de son cote.
 */
export const NOM_APPLICATION = 'Prospection B2B';

/** Sigle affiche dans la pastille de marque, en majuscules. */
export const SIGLE_APPLICATION = 'PB';

export const BASELINE_APPLICATION = 'Base de leads et suivi commercial';
